import {base_api_url} from './api.root.config'
import axios from 'axios'
import qs from 'qs'
import md5 from 'blueimp-md5'
import {getLocalStorage, removeLocalStorage, setLocalStorage,getSessionStorage,removeSessionStorage,setSessionStorage} from "./utils"



//request请求
function request(url = "", method = "GET", data = {}, isLoading = false) {
	let value=md5(url)
	let apiKey=getSessionStorage(`api_${value}`)
	if (apiKey){
		return
	}
	let lay
	if (isLoading){
		lay=layer.load()
	}
	return new Promise((resolve, reject) => {
		setSessionStorage(`api_${value}`,value)
		let promise
		let headers = {
			'Authorization': getLocalStorage('auth')
		}
		if (method === "GET") {
			promise = axios({method: 'GET', url: base_api_url + url, headers, params: data})
		} else {
			promise = axios({method: 'POST', url: base_api_url + url, headers, data: qs.stringify(data)})
		}
		promise.then(res => {
			if (res.data.code === 1) {
				resolve(res.data)
			} else if (res.data.code === 401) {
				let url = window.location.href
				window.location.href = `/login?backurl=${encodeURIComponent(url)}`
			} else if (res.data.msg) {
				layer.msg(res.data.msg.toString())
				reject(res.data)
			} else {
				layer.msg("请求出错，请稍后再试")
				reject(res)
			}
		}).catch(error => {
			layer.msg("请求出错，请稍后再试")
			reject(error)
		}).finally(()=>{
			layer.close(lay)
			removeSessionStorage(`api_${value}`)
		})
	})
}

//上传文件
function uploadFiles(url = "", data = {}, isLoading = false) {
	let value=md5(url)
	let apiKey=getSessionStorage(`api_${value}`)
	if (apiKey){
		return
	}
	let lay
	if (isLoading){
		lay=layer.load()
	}
	return new Promise((resolve, reject) => {
		setSessionStorage(`api_${value}`,value)
		let promise
		let params = getAuth()
		data = Object.assign(params, data)
		let formData = new FormData()
		Object.keys(data).forEach(key => {
			formData.append(key, data[key])
		})
		promise = axios({
			headers: {"Content-Type": "multipart/form-data", 'Authorization': getLocalStorage('auth')},
			method: 'POST',
			url: base_api_url + url,
			data: formData
		})
		promise.then(res => {
			if (res.data.code === 1) {
				resolve(res.data)
			} else if (res.data.code === 401) {
				let url = window.location.href
				window.location.href = '/login?backurl='+url
			} else if (res.data.msg) {
				layer.msg(res.data.msg.toString())
				reject(res.data)
			} else {
				layer.msg("文件上传失败，请稍后再试！")
				reject(res)
			}
		}).catch(error => {
			layer.msg("文件上传失败，请稍后再试！")
			reject(error)
		}).finally(()=>{
			layer.close(lay)
			removeSessionStorage(`api_${value}`)
		})
	})
}

//get请求
function get(url, data, isLoading = false) {
	return request(url, "GET", data, isLoading)
}

//post请求
function post(url, data, isLoading = false) {
	return request(url, "POST", data, isLoading)
}


export default {
	request,
	get,
	post,
	uploadFiles,
}
